export enum GapType {
  NO_FUNDER = 'NO_FUNDER',
  NO_CONTRACT = 'NO_CONTRACT',
  NO_INVOICING_RATE = 'NO_INVOICING_RATE',
}

export type ConfigStatus = 'yes' | 'partial' | 'no' | 'none'

export interface BillingGapRow {
  residentId: string
  residentName: string
  status: string
  fundersCount: number
  contractStatus: ConfigStatus
  invoicingRateStatus: ConfigStatus
  fundedHours: number | null
  packageHours: number | null
  gaps: GapType[]
  lastUpdated: string | null
}

export interface BillingGapsFilters {
  statuses?: string[]
  gapTypes?: GapType[]
  funderId?: string
}
